import { createComparisonStore } from "@/components/comparison/create-comparison-store";
import type { CompanyLogoValue } from "@/pages/company/company-logo";
export interface CompanyComparisonSelection { id: string; name: string; logo?: CompanyLogoValue | null }
export const useCompanyComparisonStore = createComparisonStore<CompanyComparisonSelection>();
